import { INIT_PAGE_STATE } from "../../constant/constant";

export const ENTRA_LOG_GET_LIST = "ENTRA_LOG_GET_LIST";
export const ENTRA_LOG_GET_LIST_SUCCESS = "ENTRA_LOG_GET_LIST_SUCCESS";
export const ENTRA_LOG_GET_LIST_ERROR = "ENTRA_LOG_GET_LIST_ERROR";

export const loadEntraLogList = (p) => {
  const param = {
    ...{
      selectedPage: 1,
      filter: null,
      deleteFlag: false,
      orderBy: "id",
      sortedBy: "asc",
      limit: INIT_PAGE_STATE.pageSizes[0],
      startDate: null,
      endDate: null,
      importType: null,
      syncType: null,
    },
    ...p,
  };
  const payload = {
    municipal_id: param.sourced_id,
    selectedPage: param.selectedPage,
    filter: param.filter,
    deleteFlag: param.deleteFlag,
    orderBy: param.orderBy,
    sortedBy: param.sortedBy,
    limit: param.limit,
    startDate: param.startDate,
    endDate: param.endDate,
    importType: param.importType,
    syncType: param.syncType,
  };
  console.log('loadEntraLogList payload:', payload);
  return {
    type: ENTRA_LOG_GET_LIST,
    payload,
  };
};

export const loadEntraLogListSuccess = (data) => ({
  type: ENTRA_LOG_GET_LIST_SUCCESS,
  payload: data,
});

export const loadEntraLogListError = (error) => ({
  type: ENTRA_LOG_GET_LIST_ERROR,
  payload: error,
});

